import { useAppSelector } from 'app/hooks';
import { AxiosError } from 'axios';
import AlertModal from 'components/common/AlertModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { selectIsEditMode } from 'features/common/editModeSlice';
import CONST_SUB_GENRE from 'features/SubGenre/constans';
import { SubGenre } from 'features/SubGenre/models/SubGenre';
import AddModal from 'features/SubGenre/pages/add/AddModal';
import service from 'features/SubGenre/pages/list/services';
import { useEffect, useState } from 'react';
import { Card, Col, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { handleServiceError } from 'utils';
import Filter from './components/Filter';
import TableList from './components/TableList';

export interface SubGenreAddModalReturnData {
  genreId?: number;
  selectedSubGenres: Array<{ id: number; name: string }>;
}
export interface SubGenreAddModalProps {
  isShowModal: boolean;
  genreId?: number;
  genreName?: string;
  exceptSubgenreIds?: number[];
  onReflect?: (returnData: SubGenreAddModalReturnData) => void;
  onClose: () => void;
}

function SubGenreAddModal({
  isShowModal,
  genreId,
  genreName,
  exceptSubgenreIds = [],
  onReflect,
  onClose,
}: SubGenreAddModalProps) {
  const { showGlobalModal } = useGlobalModal();

  // states
  const [nameGenre, setNameGenre] = useState('');
  const [dataTable, setDataTable] = useState<SubGenre[] | []>();
  const [showAddModal, setShowAddModal] = useState(false);
  const [fairFlg, setFairFlg] = useState(CONST_SUB_GENRE.CONST_SUB_GENRE_FILTER.ALL);

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  // call API
  async function filterAPI(name: string, fairFlg: number) {
    await service
      .getSubGenres(name, fairFlg, CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.ALL)
      .then((result) => {
        const dataFilter = result.data.filter((subGenre: SubGenre) => {
          if (!exceptSubgenreIds?.includes(subGenre.id)) {
            return subGenre;
          } else {
            return null;
          }
        });
        setDataTable(dataFilter);
      })
      .catch((error) => {
        if (!handleServiceError(showGlobalModal, error as AxiosError)) {
          showGlobalModal(() => (
            <AlertModal title={t('SubGenre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
          ));
        }
      });
  }

  // first load page
  useEffect(() => {
    async function getDataTable(name: string) {
      filterAPI(name, fairFlg).catch((error) => {
        if (!handleServiceError(showGlobalModal, error as AxiosError)) {
          showGlobalModal(() => (
            <AlertModal title={t('SubGenre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
          ));
        }
      });
    }
    getDataTable(nameGenre).catch((error) => {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        showGlobalModal(() => (
          <AlertModal title={t('SubGenre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
        ));
      }
    });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  // search name
  function callFilter() {
    filterAPI(nameGenre, fairFlg).catch((error) => {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        showGlobalModal(() => (
          <AlertModal title={t('SubGenre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
        ));
      }
    });
  }

  function handleClose() {
    onClose && onClose();
  }
  const { t } = useTranslation();

  function handleChangeName(event: React.ChangeEvent<HTMLInputElement>) {
    setNameGenre(event.target.value);
  }

  function handleCloseModalAdd(status: boolean) {
    setShowAddModal(false);
    if (status) callFilter();
  }

  function handleOnClickAddGenre() {
    setShowAddModal(true);
  }

  function handleBtnOnReflect(selectedSubGenres: Array<{ id: number; name: string }>) {
    onReflect?.({ genreId, selectedSubGenres });
  }

  function handleChangeFairFlg(event: React.ChangeEvent<HTMLInputElement>) {
    setFairFlg(parseInt(event.target.value));
  }

  return (
    <Modal show={isShowModal} backdrop="static" onHide={handleClose} centered>
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={`${genreName}｜サブジャンル追加`} />
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <Filter
          handleChangeFairFlg={handleChangeFairFlg}
          handleChangeName={handleChangeName}
          name={nameGenre}
          fairFlg={fairFlg}
          callFilter={callFilter}
        />
        <Row>
          <Col md={{ span: 6 }}></Col>
          <Col md={{ offset: 12 }}>
            <button className="pull-right html-link" onClick={handleOnClickAddGenre} style={{ cursor: 'pointer' }}>
              {t('SubGenreAddModal.link_to')}
            </button>
            <AddModal show={showAddModal} handleCloseModalAdd={handleCloseModalAdd} />
          </Col>
        </Row>
        <Card className="border-0 p-3">
          {dataTable && (
            <TableList
              dataTable={dataTable}
              handleBtnOnReflect={handleBtnOnReflect}
              setDataTable={setDataTable}
              except_subgenre_ids={exceptSubgenreIds}
            />
          )}
        </Card>
      </Modal.Body>
    </Modal>
  );
}
export default SubGenreAddModal;
